import { ErrorHandler, Injectable } from '@angular/core';
import { capturarError } from './sentry';

/**
 * TR-22 (A): reemplaza el ErrorHandler de Angular. Reporta a Sentry (si hay DSN)
 * y conserva el comportamiento por defecto (console.error).
 */
@Injectable()
export class AppErrorHandler extends ErrorHandler {
    constructor() {
        super(false);
    }

    handleError(error: any): void {
        capturarError(error);
        super.handleError(error);
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/monitoring/app-error-handler.ts